import { useEffect, useState } from "react";
import { api } from "./apiClient";

/** What this deployment actually has switched on. Until it loads we assume the minimum, so the UI never over-promises. */
const DEFAULT = { payment_methods: ["cod"], market_data_enabled: false, ai_enabled: false, support_email: "", upi_id: "", upi_name: "" };
let cache = null;
let inflight = null;

export function useConfig() {
  const [cfg, setCfg] = useState(cache || DEFAULT);
  useEffect(() => {
    if (cache) return undefined;
    let live = true;
    inflight = inflight || api.get("/config", { silent: true }).then(r => (cache = { ...DEFAULT, ...r.data })).catch(() => DEFAULT);
    inflight.then(c => { if (live) setCfg(c); });
    return () => { live = false; };
  }, []);
  return cfg;
}

export const payText = (cfg) => (cfg.payment_methods?.includes("upi") ? "UPI or cash on delivery" : "Cash on delivery");
